import React, { Component } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";

class navLink {
  constructor(display, path, displayState) {
    this.display = display;
    this.path = path;
    this.displayState = displayState;
  }
  display;
  path;
  displayState;
}

export class Nav extends Component {


  constructor(props) {
    super(props);

    var url = window.location.href.split("?")[0].toLowerCase();
    this.state = {
      loadPath: "/" + url.split("/")[3],
      navLinks: [
        new navLink("Home", "/", ""),
        new navLink("FAQ Videos", "/faqvideo", ""),
        new navLink("Pamphlets", "/pamphlet", ""),
        new navLink("About", "/about", ""),
        new navLink("Contact", "/contact", "")
      ]
    };

    this.setNav(
      Math.max(this.state.navLinks.map(l => l.path).indexOf(this.state.loadPath), 0)
    );
  }

  setNav(navIndex) {
    for (var i = 0; i < this.state.navLinks.length; i++) {
      this.state.navLinks[i].displayState = navIndex === i ? "active" : "";
    }
  }

  toggleNav() {
    var x = document.getElementById("TopNav");
    if (x.className === "topnav") {
      x.className += " responsive";
    } else {
      x.className = "topnav";
    }
  }

  render() {
    return (
      <div id="TopNav" className="topnav">
        <a
          className="icon"
          href="javascript:void(0);"
          onClick={() => this.toggleNav()}
        >
          <FontAwesomeIcon icon={faBars} /> Menu
        </a>
        {this.state.navLinks.map((link, i) => (
          <Link
            to={link.path}
            onClick={() => this.setNav(i)}
            className={link.displayState}
          >
            {link.display}
          </Link>
        ))}
      </div>
    );
  }
}

export const Footer = () => {
  const year = new Date().getFullYear();
  return <div className="footer">&copy;{year}</div>;
};
